export var LEASING_ADMIN_PERMISSION = 'LEASING_ADMIN';
export var LEASING_USER_PERMISSION = 'LEASING';
export var LEASING_CONTRACT_PROCESS_DEFINITION_ID = 'leasingContract';